import React from 'react';

import ScheduleCreateBody from './ScheduleCreateBody';
import ScheduleModifyBody from './ScheduleModifyBody';


export default function ScheduleRightSidebar(param) {

    function wrapperCheck(check) {
        param.callbackWrapperCheck(false);
    }
    

    return(
        
        <div className="bg-light border-right" id="sidebar-wrapper">

                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                        <div className="col-sm-6">
                        <i className="fas fa-sign-in-alt fa-2x" onClick={wrapperCheck}></i>
                        </div>
                        </div>
                    </div>
                </section>
                {
                    param.scheduleId === "" ? <ScheduleCreateBody clear={param.clear} contentCheck={param.contentCheck} type={param.type} projectId={param.projectId} programId={param.programId} scheduleId={param.scheduleId}/>
                    :
                    <ScheduleModifyBody type={param.type} projectId={param.projectId} programId={param.programId} scheduleId={param.scheduleId}/>

                }
        </div>

    );
}